import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TGpsrApi } from './types';

export const gpsr: TGpsrApi = {
	getGpsrStatus: () => http.get(endpoint.gpsr.GET_STATUS).then((response) => response.data),

	getGpsrProductTypes: (payload) =>
		http.post(endpoint.gpsr.GET_AVAILABLE_PRODUCT_TYPES, payload).then((response) => response.data),

	getGpsrSkus: (payload) =>
		http
			.post(endpoint.gpsr.GET_SKUS(payload.productTypeId), payload.body)
			.then((response) => response.data),
	attachSkus: (payload) =>
		http
			.post(endpoint.gpsr.ATTACH_SKUS(payload.productTypeId), payload.body)
			.then((response) => response.data),
	deleteSku: (payload) =>
		http.delete(endpoint.gpsr.DELETE_SKUS(payload.productTypeId, payload.skuId)),
	generateGpsrDoc: (payload) =>
		http
			.post(endpoint.gpsr.GENERATE_DOC(payload.productTypeId), payload.body, {
				responseType: 'blob',
			})
			.then((response) => response.data),
	uploadGpsrDoc: (payload) =>
		http.post(endpoint.gpsr.UPLOAD_DOC(payload.productTypeId), payload.file),
	downloadGpsrDoc: (payload) =>
		http
			.get(endpoint.gpsr.GET_DOC(payload.productTypeId), { responseType: 'blob' })
			.then((response) => response.data),
	updateGpsrDescription: (payload) =>
		http
			.post(endpoint.gpsr.UPDATE_DESCRIPTION(payload.productTypeId), payload.body)
			.then((response) => response.data),
	uploadGpsrTechFile: (payload) =>
		http.post(endpoint.gpsr.UPLOAD_TECH_FILE(payload.productTypeId), payload.file),
	getGpsrTechFile: (payload) =>
		http
			.get(endpoint.gpsr.GET_TECH_FILE(payload.productTypeId), { responseType: 'blob' })
			.then((response) => response.data),
	getGpsrAdditionalInformation: () =>
		http.get(endpoint.gpsr.ADDITIONAL_INFORMATION).then((response) => response.data),
	getGpsrCancellation: () => http.post(endpoint.gpsr.CANCELLATION),
	getGpsrPlans: () => http.get(endpoint.gpsr.PLANS).then((response) => response.data),
	changeGpsrServiceRequest: (payload) => http.post(endpoint.gpsr.CHANGE_SERVICE_REQUEST, payload),
	confirmAdditionalInformation: () => http.post(endpoint.gpsr.CONFIRM_ADDITIONAL_INFORMATION),
};
